export default __webpack_public_path__ + "static/media/h.bf5beb23.svg";